import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { PracticalInformationForm } from 'src/Components/Forms/PracticalInformation/PracticalInformationForm';
import { useCreatePracticalInformationForm } from 'src/Hooks/Forms/useCreatePracticalInformationForm';
import { useAddPracticalInformationAttachments } from 'src/Hooks/Mutations/useAddPracticalInformationAttachments';
import { useCreatePracticalInformation } from 'src/Hooks/Mutations/useCreatePracticalInformation';
import {
  CreatePracticalInformationDtoSubtypeEnum,
  CreatePracticalInformationDtoTypeEnum,
} from 'src/Services/API/generated';

import { Props } from './PracticalInformationCreationFormWrapper.types';

interface PracticalInformationCreationLocationState {
  type?: CreatePracticalInformationDtoTypeEnum;
  subtype?: CreatePracticalInformationDtoSubtypeEnum;
}

const PracticalInformationCreationFormWrapper = ({ onCreate, onCancel }: Props) => {
  const location = useLocation();
  const initialValues =
    (location.state as PracticalInformationCreationLocationState | null) ?? undefined;
  const form = useCreatePracticalInformationForm(initialValues);
  const { mutate: addAttachments } = useAddPracticalInformationAttachments();
  const { mutate } = useCreatePracticalInformation({
    onSuccess: data => {
      const fileIds = form.values.attachments
        .map(attachment => attachment.fileId)
        .filter((fileId): fileId is string => Boolean(fileId));
      if (fileIds.length > 0) {
        addAttachments({ practicalInformationId: data.id, fileIds });
      }
      onCreate();
    },
  });
  const { t } = useTranslation();

  return (
    <PracticalInformationForm
      onCancel={onCancel}
      form={form}
      onSubmit={form.onSubmit(values => {
        mutate(values);
      })}
      submitButtonLabel={t('createPracticalInformationForm.addEvent', 'Ajouter')}
    />
  );
};

export default PracticalInformationCreationFormWrapper;
